import React from 'react';

/** Branded confirmation dialog; avoids browser-native host-name titles. */
export default function ConfirmModal({
    open,
    title = 'Console Confirmation',
    message,
    confirmLabel = 'OK',
    cancelLabel = 'Cancel',
    danger = false,
    onConfirm,
    onCancel,
}) {
    React.useEffect(() => {
        if (!open) return undefined;
        const onKey = (event) => { if (event.key === 'Escape') onCancel?.(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, onCancel]);

    if (!open) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onCancel}>
            <div style={{ background: '#fff', borderRadius: 8, padding: 24, maxWidth: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }} onClick={event => event.stopPropagation()}>
                <h3 style={{ margin: '0 0 12px', fontSize: 16, color: '#3C4043' }}>{title}</h3>
                <div style={{ margin: '0 0 20px', fontSize: 14, color: '#5F6368', lineHeight: 1.5 }}>{message}</div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button onClick={onCancel} style={{ padding: '6px 16px', border: '1px solid #DADCE0', borderRadius: 4, background: '#fff', color: '#3C4043', cursor: 'pointer', fontSize: 13 }}>{cancelLabel}</button>
                    <button onClick={onConfirm} autoFocus style={{ padding: '6px 16px', border: 'none', borderRadius: 4, background: danger ? '#D32F2F' : '#1967D2', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>{confirmLabel}</button>
                </div>
            </div>
        </div>
    );
}
